import { render, staticRenderFns } from "./eduProceed.vue?vue&type=template&id=6711eb30&scoped=true"
import script from "./eduProceed.vue?vue&type=script&lang=js"
export * from "./eduProceed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6711eb30",
  null
  
)

export default component.exports